import { getAlertHistory } from 'app/business-logic/services/alerts-services/getAlertHistory';

export const fetchAlertHistory = getAlertHistory;
export type AlertHistory = Awaited<ReturnType<typeof fetchAlertHistory>>;
